export enum FileFormatTypes {
  PDF = "PDF",
  JPG = "JPG",
  PNG = "PNG",
}